// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".act-valentine-bean{width:1.06667rem;height:1.06667rem}", ""]);
// Exports
module.exports = exports;
